import { initializeEnvironment } from "@/common/services/chat"
import { getBackendUrl, isDevelopment } from "@/config/env"

/**
 * Initialize shared package config with frontend environment variables
 * Must be called BEFORE Redux store creation to ensure WebSocket connects to correct URL
 */
export const initializeSharedConfig = (): void => {
  initializeEnvironment({
    backendUrl: getBackendUrl(),
    isDevelopment
  })
}
